import { render } from "./CreateRequestModal.vue?vue&type=template&id=5fbcd208&scoped=true"
import script from "./CreateRequestModal.vue?vue&type=script&lang=js"
export * from "./CreateRequestModal.vue?vue&type=script&lang=js"

import "./CreateRequestModal.vue?vue&type=style&index=0&id=5fbcd208&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbcd208"]])

export default __exports__